import { render } from "./ProjectView.vue?vue&type=template&id=d5798b14"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-a/.jenkins/workspace/Sunga/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__